<template>  
    <div id="ubn" class="card card-body mt-4 pt-3">
      <div class="row justify-content-center align-items-center">        
        <div class="col-sm-auto col-8 my-auto">
          <div class="h-100 p-4">
            <h5 class="mb-1 font-weight-bolder">{{ $t('mating.UBN') }}: {{ state.ubn }}</h5>
            <p class="mb-0  text-sm">
              {{ state.associationName }}            
            </p>
          </div>
        </div>
        <div class="col-sm-auto ms-sm-auto mt-sm-0 mt-3 d-flex">          
        </div>
      </div>
    </div>    
    <div class="row mt-4">
      <div id="male" class="col-md-6">
        <div class="card pt-3" data-animation="FadeIn">
          <div class="card-header">
            <h5>{{ $t('mating.Male') }}</h5>
            <p class="mb-0 text-sm text-green" v-if="state.maleLeased">
              {{ $t('mating.Male_leased_from_UBN') }} {{ state.maleLeaseUbn }}
            </p>
          </div>
          <div class="card-body pt-0">   
            <div class="row">          
              <div class="col-12">
                <div class="mb-4">
                  <div class="input-group input-group-static null">
                    <label>{{ $t('mating.Male_details') }}:</label>
                    <div class="display-field">
                      {{ state.maleLeaseUbn }} | {{ state.maleStudbookNumber }} | {{ state.maleAnimalNumber }} 
                      {{ state.maleName ? '(' + state.maleName + ')' : '' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>      
          </div>
        </div>
      </div>
      <div id="female" class="col-md-6">
        <div class="card pt-3" data-animation="FadeIn">
          <div class="card-header">
            <h5>{{ $t('mating.Female') }}</h5>
            <p class="mb-0 text-sm text-green" v-if="state.maleLeased">
              &nbsp;
            </p>
          </div>
          <div class="card-body pt-0">   
            <div class="row">
              <div class="col-12">
                <div class="mb-4">
                  <div class="input-group input-group-static null">
                    <label>{{ $t('mating.Female_details') }}:</label>
                    <div class="display-field">
                      {{ state.ubn }} | {{ state.femaleStudbookNumber }} | {{ state.femaleAnimalNumber }} 
                      {{ state.femaleName ? '(' + state.femaleName + ')' : '' }}
                    </div>
                  </div>
                </div>
              </div>  
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="date" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('mating.Date') }}</h5>        
        <p class="mb-0 text-sm">{{ $t('common.Mandatory_informations') }} *</p>
        <p class="mb-0 text-sm  text-green">{{ $t('mating.Mating_date') }}: {{ matingDateRange }}</p>   
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-4">
              <div class="input-group input-group-static null">
                  <label class="">{{ $t('mating.Birth_date') }} *</label>
                  <input v-model="state.birthDate" type="date" :max="todayDate" class="form-control form-control-default" :placeholder="$t('mating.Birth_date')" v-if="!state.offspringAdded">
                  <span v-if="vrulesBirth$.birthDate.$error" class="text-sm text-danger">
                    {{ vrulesBirth$.birthDate.$errors[0].$message }}
                  </span>
                  <div class="display-field" v-if="state.offspringAdded">
                    {{ state.birthDate }}
                  </div>
              </div>
          </div>
        </div> 
        <div class="row">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('mating.No_of_born') }} *</label>
              <input v-model="state.noOfBirth" type="text" class="form-control form-control-default" :placeholder="$t('mating.No_of_born')" v-if="!state.offspringAdded">
              <span v-if="vrulesBirth$.noOfBirth.$error" class="text-sm text-danger">
                {{ vrulesBirth$.noOfBirth.$errors[0].$message }}
              </span>
              <div class="display-field" v-if="state.offspringAdded">
                {{ state.noOfBirth }}
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('mating.No_of_death') }}</label>
              <input v-model="state.noOfDeath" type="text" class="form-control form-control-default" :placeholder="$t('mating.No_of_death')" v-if="!state.offspringAdded">
              <span v-if="vrulesBirth$.noOfDeath.$error" class="text-sm text-danger">
                {{ vrulesBirth$.noOfDeath.$errors[0].$message }}
              </span>
              <div class="display-field" v-if="state.offspringAdded">
                {{ state.noOfDeath }}
              </div>
            </div>
          </div>
        </div> 
        <div class="row mt-4" v-if="!state.offspringAdded">
          <div class="col-12">
            <button v-on:click="updateBirth" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('mating.Update_birth') }}</button>      
          </div>   
        </div>        
      </div>    
    </div>
    <div id="delete" class="card mt-4" v-if="!state.offspringAdded">
      <div class="card-header">
        <h5>{{ $t('common.Delete') }}</h5>
        <p class="text-sm mb-0">
          {{ $t('common.Once_you_delete_there_is_no_going_back_Please_be_certain') }}
        </p>
      </div>
      <div class="card-body d-sm-flex pt-0">
        <div class="d-flex align-items-center mb-sm-0 mb-4">
          <div>
            <material-switch id="deleteMating" name="Delete" v-model="state.deleteMating"/>
          </div>
          <div class="ms-2">
            <span class="text-dark font-weight-bold d-block text-sm">{{ $t('common.Confirm') }}</span>
            <span class="text-xs d-block">{{ $t('common.Delete_for') }} {{ state.ubn }}.</span>
          </div>
        </div>        
        <button class="btn mb-0 bg-gradient-danger btn-sm null null mb-0 ms-2" type="button" :disabled="!state.deleteMating" @click="deleteMating" name="button">{{ $t('mating.Delete_mating') }}</button>
      </div>
    </div>    
  </template>
  
  <script>
  import axios from 'axios'
  import { useVuelidate } from '@vuelidate/core'
  import { required, helpers, } from '@vuelidate/validators'
  import { reactive, computed, watch } from 'vue'  
  import { useI18n } from 'vue-i18n'
  import MaterialSwitch from "@/components/MaterialSwitch.vue";

  export default {
    name: "BirthDetailItem",
    props: {
      offspringAdded: Boolean
    },
    setup(props, { emit }) {
        
      const { t } = useI18n()
      const todayDate = new Date().toISOString().split('T')[0]; 
      const state = reactive ({        
        gets: [],

          id: '',
          ubnId: '',
          maleId: '',
          femaleId: '',
          dateFrom: null,
          dateTo: null,
          inbreedFactorOffspring: 0,
          birthDate: null,
          noOfBirth: 0,
          noOfDeath: 0,          
          maleLeasedFromUBNId: '',
          groupGuid: '',
          maleLeased: false,
          ubn: '',
          locationName: '',
          maleTagNumber: '',
          maleAnimalNumber: '',
          maleName: '',
          maleKeeperNumber: '',
          maleStudbookNumber: '',
          maleKeeperName: '',
          femaleTagNumber: '',
          femaleAnimalNumber: '',
          femaleName: '',
          femaleKeeperNumber: '',
          femaleStudbookNumber: '',
          femaleKeeperName: '',
          associationId: '',
          associationName: '',
          maleLeaseUbn: '',
          noOfAlive: 0,
          offspringAdded: false,
          deleteMating: false
    })
    
    watch(() => state.offspringAdded, (val) => {
      emit('update:offspringAdded', val);
    });

    const matingDateRange = computed(() => {
      const format = (date) =>
        new Intl.DateTimeFormat('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(date))
      return `${format(state.dateFrom)} ${t('mating.To')} ${format(state.dateTo)}`
    })

    const integerOnly = helpers.withMessage(
      t('common.Integer_only'),
      value => {
        if (value === '' || value === null || value === undefined) return true; // allow empty
        return /^[0-9]+$/.test(value); // only allow integers
      }
    )

    const rulesBirth = computed(() => {
      return {
        birthDate: { 
          required: helpers.withMessage(t('common.Required'), required) 
        },          
        noOfBirth: { 
          required: helpers.withMessage(t('common.Required'), required),
          integerOnly
        },
        noOfDeath: { 
          integerOnly 
        }
      }
    });
    
    const vrulesBirth$ = useVuelidate(rulesBirth, state)

    return {
        state,
        matingDateRange,
        vrulesBirth$,
        todayDate
      }
  },
  components: {      
    MaterialSwitch,
  },  
  async mounted() {  
    this.id = this.$route.params.id;
    this.type = this.$route.params.type; // Can be group or single
    
    try {
          this.$store.commit('setShowLoading', true);
          await this.loadAll();

      } catch(e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      } finally {
        this.$store.commit('setShowLoading', false);
      }
  },
  methods: {
    async loadAll() {
      await this.fetchMatingData(this.id);        
    },
    async fetchMatingData(id) {
      try {
          this.$store.commit('setShowLoading', true);

          const response = await axios.get(`mating/${id}`);
          this.gets = response.data;
          
          if (this.gets.success) {
              this.state.mating = this.gets.data;

              this.state.id = this.state.mating.id;
              this.state.ubnId = this.state.mating.ubnId;
              this.state.maleId = this.state.mating.maleId;
              this.state.femaleId = this.state.mating.femaleId;
              this.state.dateFrom = this.state.mating.dateFrom;
              this.state.dateTo = this.state.mating.dateTo;
              this.state.inbreedFactorOffspring = this.state.mating.inbreedFactorOffspring;
              this.state.birthDate = this.state.mating.birthDate;
              this.state.noOfBirth = this.state.mating.noOfBirth;
              this.state.noOfDeath = this.state.mating.noOfDeath;
              this.state.maleLeasedFromUBNId = this.state.mating.maleLeasedFromUBNId;
              this.state.groupGuid = this.state.mating.groupGuid;
              this.state.maleLeased = this.state.mating.maleLeased;
              this.state.ubn = this.state.mating.ubn;
              this.state.locationName = this.state.mating.locationName;
              this.state.maleTagNumber = this.state.mating.maleTagNumber;
              this.state.maleAnimalNumber = this.state.mating.maleAnimalNumber;
              this.state.maleStudbookNumber = this.state.mating.maleStudbookNumber;
              this.state.maleName = this.state.mating.maleName;
              this.state.maleKeeperNumber = this.state.mating.maleKeeperNumber;
              this.state.maleKeeperName = this.state.mating.maleKeeperName;
              this.state.femaleTagNumber = this.state.mating.femaleTagNumber;
              this.state.femaleAnimalNumber = this.state.mating.femaleAnimalNumber;
              this.state.femaleStudbookNumber = this.state.mating.femaleStudbookNumber;
              this.state.femaleName = this.state.mating.femaleName;
              this.state.femaleKeeperNumber = this.state.mating.femaleKeeperNumber;
              this.state.femaleKeeperName = this.state.mating.femaleKeeperName;
              this.state.associationId = this.state.mating.associationId;
              this.state.associationName = this.state.mating.associationName;
              this.state.maleLeaseUbn = this.state.mating.maleLeaseUbn;
              this.state.noOfAlive = this.state.mating.noOfAlive;
              this.state.offspringAdded = this.state.mating.offspringAdded;

          } else {
            this.$showError('errors.Contact_system_admin');
          }
      } catch(e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      } finally {
        this.$store.commit('setShowLoading', false);
      }
    },            
    async updateBirth() {   
      try {
          this.$store.commit('setShowLoading', true);            
          
          const valid = await this.vrulesBirth$.$validate();
          if (!valid) return;

          const response = await axios.put('mating/updatebirth', {
            id: this.state.id,              
            birthDate: this.state.birthDate || null,
            noOfBirth: this.state.noOfBirth,
            noOfDeath: this.state.noOfDeath
          });
          this.gets = response.data;
          
          if (this.gets.success) {
            this.$showSuccess('errors.Success_birth_updated_successfully');
            this.$router.push('/mating');
            //this.$router.push(`/birth/addnewborn/${this.state.id}/${this.state.ubnId}`);
          } else {
            this.$showError('errors.Contact_system_admin');
          }
      } catch (e) {
        const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
        this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      } finally {
        this.$store.commit('setShowLoading', false);
      }
    },    
    deleteMating() {
      if (this.state.deleteMating) {
        this.deleteMating1(this.state.id)
      }
    },                  
    async deleteMating1(id) {   
      try {
          
          this.$store.commit('setShowLoading', true);

          const response = await axios.delete("mating/" + id);
          this.gets = response.data;

          if (this.gets.success) {

            this.$showSuccess('errors.Success_mating_deleted_successfully');
            
            this.$router.push('/birth');                
          } else {
            this.$showError('errors.Contact_system_admin');
          }
      } catch (e) {          
        const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
        this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      } finally {
        this.$store.commit('setShowLoading', false);
      }
    }
  }
};
  </script>

  <style scoped>
  .card {
    transition: background-color 0.2s ease-in-out;
    cursor: pointer;
    position: relative;
    padding: 10px !important;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .bg-light {
    background-color: #f9f9f9 !important;
  }
  .border-success {
    border-color: #28a745 !important;
  }
 
  .display-field {
    display: block;
    width: 100%;
    border: none;
    border-bottom: 1px solid #4ca750;
    padding: 2px 0;
    margin-top: 2px;
    background-color: transparent;  
    font-size: 0.875rem;
  }

  .card-shadow-all {
    box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.1);
  }

  .card-body .input-group-static {
    margin-bottom: 5px;
  }

  .card-body .form-control {
    padding: 8px;    
    border-radius: 4px;
  }

  .card-body label {  
    font-size: 0.875rem;
    font-weight: 400;
    color: #7b809a;
  }

  .font-size-18 {
    font-size: 18px !important;
  }
</style>